import "bootstrap";
import "bootstrap/dist/css/bootstrap.css";
import "bootstrap-vue-next/dist/bootstrap-vue-next.css";
import "@vuepic/vue-datepicker/dist/main.css";
import "./assets/app.css";
import "./assets/styles.scss";
import "../node_modules/vue-toastification/dist/index.css";

import { createBootstrap } from "bootstrap-vue-next";
import { Chart, registerables } from "chart.js";
import { createApp } from "vue";
import { createPinia } from "pinia";
import PrimeVue from "primevue/config";
import Toast from "vue-toastification";
import Aura from "@primevue/themes/aura";
import App from "./App.vue";
import router from "./router";
import { useUserStore } from "./stores/user";
import { useAuthStore } from "./stores/auth";

Chart.register(...registerables);

const app = createApp(App);

app.use(createPinia());
app.use(Toast);
app.use(createBootstrap());
// app.use(router);
app.use(PrimeVue, {
  theme: {
    preset: Aura,
    options: {
      darkModeSelector: ".my-app-dark",
    },
  },
});

window.instances = {};

// initialize user permissions before routes
// routes check if the user has permissions before allowing access
const initAuth = async () => {
  const userStore = useUserStore();
  const authStore = useAuthStore();

  const isLoggedIn = await authStore.isLoggedIn();

  // user is logged in, fetch profile
  if (isLoggedIn && !userStore.perms) {
    await userStore.fetchMyProfile();
  }

  // initialize router
  app.use(router);
};

const handleClickOutside = (event) => {
  Object.keys(window.instances).forEach((item) => {
    window.instances[item]();
  });
};
window.addEventListener("click", handleClickOutside);

// initialize auth then mount app
initAuth().then(() => app.mount("#app"));
